export default {
  SET_STATE_LOADER: (state, payload) => {
    state.loader = payload;
  },
  STORE_FIREBASE_PAGE: (state, payload) => {
    state.pages[payload.city][payload.page] = payload.content;
  },
  STORE_FIREBASE_COMPONENTS: (state, payload) => {
    state.components = payload.components;
  },
  STORE_SINGLE_SPEAKER: (state, payload) => {
    state.speakers[payload.city][payload.key] = payload.data;
  },
  STORE_ALL_SPEAKERS: (state, payload) => {
    state.speakers[payload.city] = payload.data;
  },
  STORE_ALL_MEDIA: (state, payload) => {
    state.media = payload;
  },
};
